import moment from "moment";

const LIVE_COLOR = "#16a34a";
const DUE_COLOR = "#f37b21";
const END_COLOR = "#ef3a45";
const CANCELLED_COLOR = "#4b4b4b";

/**
 * Race colour shared by race cards, race detail and race number tabs:
 * - Live (green): race start time not reached yet
 * - Due (orange): start time has passed but results are not entered yet
 * - End (red): results entered / race completed
 * - Cancelled (grey)
 */
export function getRaceStatusColor(raceStatus, raceData) {
  if (raceStatus === "Cancelled" || raceStatus === "Cancel") return CANCELLED_COLOR;

  const hasResults = Boolean(
    raceData?.FirstRankHorseEnglish ||
    raceData?.SecondRankHorseEnglish ||
    raceData?.ThirdRankHorseEnglish ||
    raceData?.FirstRankHorseArabic ||
    raceData?.SecondRankHorseArabic ||
    raceData?.ThirdRankHorseArabic ||
    (raceData?.RaceResultData && raceData.RaceResultData.length > 0)
  );

  if (hasResults || raceStatus === "Completed" || raceStatus === "End") return END_COLOR;

  if (raceStatus === "Due") return DUE_COLOR;
  if (raceData?.StartTime && moment().isAfter(moment(raceData.StartTime))) return DUE_COLOR;

  return LIVE_COLOR;
}
